$shm_agent_session_menu $shm_remove_menu
	pinned? false
	archived? false
	Archive $mol_button_minor
		title <= archive_title \
		click? <=> archive_toggle? null
	Pin $mol_button_minor
		title <= pin_title \
		click? <=> pin_toggle? null
